<script setup lang="ts">
import ButtonV2 from '../ButtonV2/ButtonV2.vue';

const props = defineProps<{
  actionButtonLabel: string;
  cancelButtonLabel?: string;
  danger?: boolean;
  disabled?: boolean;
  /**
   * When set, the action button becomes a native submit button for the form
   * referenced by `formId`, so pressing Enter inside that form triggers the
   * primary action. In this mode the action runs through the form's `submit`
   * event (not `onAction`), so `onAction` is intentionally not emitted on
   * click to avoid a double-trigger. The cancel button stays a plain button.
   */
  submit?: boolean;
  /** `id` of the `<form>` the action button should submit (see `submit`). */
  formId?: string;
  /**
   * Focus the action button when the footer mounts. Use for confirm dialogs
   * that have no form fields, so Enter triggers the primary action instead of
   * leaking back to the control that opened the modal.
   */
  autofocusAction?: boolean;
}>();

const emits = defineEmits<{
  onAction: [];
  onCancel: [];
}>();
</script>

<template>
  <div class="mt-8 flex justify-end gap-2">
    <ButtonV2
      v-if="props.cancelButtonLabel"
      :label="props.cancelButtonLabel"
      variant="neutral"
      @click="emits('onCancel')"
    />
    <ButtonV2
      :disabled="props.disabled"
      :variant="props.danger ? 'danger' : 'primary'"
      :label="props.actionButtonLabel"
      :type="props.submit ? 'submit' : 'button'"
      :form-id="props.submit ? props.formId : undefined"
      :autofocus="props.autofocusAction"
      @click="!props.submit && emits('onAction')"
    />
  </div>
</template>
